import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  pushSupported,
  getPushPermission,
  isSubscribed,
  subscribeToPush,
  unsubscribeFromPush,
} from "@/lib/pushClient";

export default function NotificationButton({ className = "" }) {
  const [supported, setSupported] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [permission, setPermission] = useState("default");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      if (!pushSupported()) {
        setSupported(false);
        return;
      }
      setSupported(true);
      setPermission(await getPushPermission());
      setSubscribed(await isSubscribed());
    })();
  }, []);

  if (!supported) return null;
  if (permission === "denied") {
    return (
      <div
        className={`text-xs text-orange-600 ${className}`}
        data-testid="notifications-denied"
      >
        Notifiche bloccate dal browser
      </div>
    );
  }

  const handleEnable = async () => {
    setBusy(true);
    try {
      await subscribeToPush();
      setSubscribed(true);
      setPermission("granted");
      toast.success("Notifiche attivate. Riceverai un avviso ad ogni nuovo rapportino.");
    } catch (e) {
      toast.error(e.message || "Attivazione notifiche non riuscita");
    } finally {
      setBusy(false);
    }
  };
  const handleDisable = async () => {
    setBusy(true);
    try {
      await unsubscribeFromPush();
      setSubscribed(false);
      toast.success("Notifiche disattivate");
    } catch (e) {
      toast.error("Disattivazione non riuscita");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={subscribed ? handleDisable : handleEnable}
      disabled={busy}
      className={`h-10 ${className}`}
      data-testid="notifications-toggle"
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin md:mr-2" />
      ) : subscribed ? (
        <Bell className="h-4 w-4 md:mr-2 text-[#0044FF]" />
      ) : (
        <BellOff className="h-4 w-4 md:mr-2 text-slate-500" />
      )}
      <span className="hidden md:inline">
        {subscribed ? "Notifiche attive" : "Attiva notifiche"}
      </span>
    </Button>
  );
}
